import { RouteType } from "../app/routes/types";

export const getActiveRoute = (locationPathname: string) => {
    if (locationPathname.includes(RouteType.Edit.replace("/:form_id", ""))) return RouteType.Edit;

    if (locationPathname.includes(RouteType.Design.replace("/:form_id", ""))) return RouteType.Design;

    if (locationPathname.includes(RouteType.Logic.replace("/:form_id", ""))) return RouteType.Logic;

    if (locationPathname.includes(RouteType.Validation.replace("/:form_id", ""))) return RouteType.Validation;

    if (locationPathname.includes(RouteType.Integration.replace("/:form_id", ""))) return RouteType.Integration;

    if (locationPathname.includes(RouteType.Payment.replace("/:form_id", ""))) return RouteType.Payment;

    if (locationPathname.includes(RouteType.Preview.replace("/:form_id", ""))) return RouteType.Preview;

    return null;
};
